import {ErrorPageTemplate} from './page'
import * as React from 'react'

export class NotAuthorisedError extends React.PureComponent<{}> {
  public render() {
    return (
      <ErrorPageTemplate errorCode="403" errorMessage="You are not authorised to view this page" />
    )
  }
}
